module.exports = __webpack_public_path__ + "media/images/icons/twotone/play-circle-d2feb441a46cf7df97e61ff967c248df.svg";